import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  selector: 'mj-tile-grid',
  templateUrl: 'tile-grid.component.html',
  styleUrls: ['tile-grid.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TileGridComponent {
  @Input() type?: string = 'tiles';

  get classes() {
    return this.type === 'tiles' ? 'grid-tiles' : 'grid-columns';
  }
}
